
import { unref } from "vue";
import { createWebHistory, createRouter } from "vue-router";

import useAuthStore from "../stores/AuthStore";
import useActiveProviderStore from "../stores/ActiveProviderStore";


// Default pages
import DashboardPage from "./views/DashboardPage.vue";
import LoginPage from "./views/LoginPage.vue";


const routes = [
	{
	  path: "/login",
	  name: "Login",
	  component: LoginPage,
	  meta:{
		  title : 'Login to your account',
	  },
	},

	{
	  path: "/password",
	  name: "Password",
      component: ()=>import('./views/PasswordPage.vue'),
	  meta:{
		  title : 'Reset your password',
          layout : 'MINIMAL',
	  },
	},

	{
	  path: "/recover",
	  name: "Recover",
      component: ()=>import('./views/RecoverPage.vue'),
	  meta:{
		  title : 'Set a new password',
          layout : 'MINIMAL',
	  },
	},
	{
	  path: "/register",
	  name: "Register",
	  component: ()=>import('./views/RegisterPage.vue'),
	},

	// HOME
	{
		path: "/",
		name: "Dashboard",
		component: DashboardPage,
	},
	{
		path: "/settings",
		name: "Settings",
		component: ()=>import('./views/SettingsPage.vue'),
	},

	{
		path: "/error",
		name: "Error",
		component: ()=>import('./views/ErrorPage.vue'),
	},
	{
		path: "/:catchAll(.*)",
		name: "NotFound",
		component: ()=>import('./views/NotFoundPage.vue'),
	},
];

const router = createRouter({
  history: createWebHistory( '/u' ),
  routes,
});

const unprotected_routes = ['Login','Register','Error','NotFound','Password','Recover'];
const Auth = useAuthStore();

router.beforeEach( async (to, from, next) => {
	try {
		const logged_in = await Auth.check();
		const going_to_a_secured_route = !unprotected_routes.includes(to.name);

		if ( going_to_a_secured_route && !logged_in ){
			next({name:'Login'});
		} else {
			next();
		}
	} catch (error) {
		if((error.response||{}).status == 401){
			Auth.logout();
			next({ name: 'Login' , query: { redirect: to.path }});
		}
	}
})

router.afterEach((to,from,failure)=>{
	const page_title = (to.meta||{}).title || to.name || 'MISSING PAGE TITLE';
	document.title = page_title+' | User panel';
})


export default router;
